import { render, staticRenderFns } from "./ChecklistEditor.vue?vue&type=template&id=5723e5f4&"
import script from "./ChecklistEditor.vue?vue&type=script&lang=js&"
export * from "./ChecklistEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports